import React, { Component } from "react";
import { connect } from "react-redux";
import Form, { Item } from "devextreme-react/form";
import Utils from "Utils";
import {
  ticket_size_range,
  countryList,
  cityList,
  investorType,
  whoseContactList,
  investorStatus,
  priority,
} from "formFields";
function mapStateToProps(state) {
  return {
    formFields: state.formFields,
  };
}
class ReportsFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showFilter: false,
      investorFilters: {
        city: null,
        country: null,
        ticket_size_gt: null,
        ticket_size_lt: null,
        industries: null,
        client_segments: null,
        sector: null,
        preferred_stages: null,
        type: null,
        contact_person: null,
        status: null,
        text: null,
        relationship_manager: null,
        tags: null,
      },
    };
    this.toggleFilter = () => {
      this.setState({
        showFilter: !this.state.showFilter,
      });
    };
    this.applyFilter = (e) => {
      if (e) {
        e.preventDefault();
      }
      var formData = { ...this.state.investorFilters };
      // removing the null object keys
      Object.keys(formData).forEach(
        (key) => formData[key] == null && delete formData[key]
      );
      if (Object.keys(formData).length) {
        this.props.applyFilter(formData);
      } else {
        Utils.notify("Please fill some values in filters", "warning");
      }
      // this.toggleFilter();
    };
    this.clearFilter = () => {
      let formData = { ...this.state.investorFilters };
      // clearing the form value
      Object.keys(formData).forEach((key) => {
        formData[key] = null;
      });
      this.setState({ investorFilters: formData }, () => {
        this.props.applyFilter({});
      });
    };
    this.formFieldDataChange = (e) => {
      var formData = { ...this.state.investorFilters };
      // removing the null object keys
      Object.keys(formData).forEach(
        (key) => formData[key] == null && delete formData[key]
      );
      this.props.applyFilter(formData);
    };
  }

  static getDerivedStateFromProps(props, state) {
    return {
      disabled: props.disabled,
      type: props.type,
    };
  }

  componentDidMount() {
    Utils.getFormFields();
  }

  render() {
    return (
      <>
        <div className={`flex justify-center`}>
          <button
            onClick={this.toggleFilter}
            style={{ marginBottom: 10 }}
            className={`btn btn-white btn-round btn-just-icon`}
          >
            <i
              className="fa fa-filter"
              style={{ color: this.state.showFilter ? "#9e56b0" : "" }}
            ></i>
            <div className="ripple-container"></div>
          </button>
        </div>
        <div className="row" style={{ padding: 10 }}>
          <div
            className="container"
            style={{
              display: this.state.showFilter ? "flex" : "none",
            }}
          >
            <form onSubmit={this.applyFilter}>
              <Form
                colCount={5}
                formData={this.state.investorFilters}
                onFieldDataChanged={
                  !this.props.showApplyButton && this.formFieldDataChange
                }
              >
                <Item
                  dataField="country"
                  label={{ visible: false }}
                  editorType="dxSelectBox"
                  editorOptions={{
                    dataSource: countryList,
                    stylingMode: "underlined",
                    placeholder: "Countries",
                    searchEnabled: true,
                    onValueChanged: this.countryChanged,
                  }}
                />
                <Item
                  dataField="city"
                  label={{ visible: false }}
                  editorType="dxSelectBox"
                  editorOptions={{
                    dataSource: cityList,
                    stylingMode: "underlined",
                    placeholder: "Cities",
                    searchEnabled: true,
                  }}
                />
                <Item
                  label={{ visible: false }}
                  dataField="ticket_size_gt"
                  editorType="dxSelectBox"
                  editorOptions={{
                    dataSource: ticket_size_range,
                    placeholder: "Ticket size greater than",
                    stylingMode: "underlined",
                  }}
                />
                <Item
                  label={{ visible: false }}
                  dataField="ticket_size_lt"
                  editorType="dxSelectBox"
                  editorOptions={{
                    dataSource: ticket_size_range,
                    placeholder: "Ticket size less than",
                    stylingMode: "underlined",
                  }}
                />
                <Item
                  label={{ visible: false }}
                  dataField="industries"
                  editorType="dxSelectBox"
                  editorOptions={{
                    dataSource: this.props.formFields.industry_choices,
                    stylingMode: "underlined",
                    placeholder: "Industries",
                  }}
                />
                <Item
                  label={{ visible: false }}
                  dataField="preferred_stages"
                  editorType="dxSelectBox"
                  editorOptions={{
                    dataSource: this.props.formFields.preferred_stage_choices,
                    stylingMode: "underlined",
                    placeholder: "Preferred Stage",
                  }}
                />
                <Item
                  label={{ visible: false }}
                  dataField="client_segments"
                  editorType="dxSelectBox"
                  editorOptions={{
                    dataSource: this.props.formFields.client_segment_choices,
                    stylingMode: "underlined",
                    placeholder: "Client Segment",
                  }}
                />
                <Item
                  label={{ visible: false }}
                  dataField="sector"
                  editorType="dxSelectBox"
                  editorOptions={{
                    dataSource: this.props.formFields.sector_choices,
                    stylingMode: "underlined",
                    placeholder: "Sectors",
                  }}
                />
                <Item
                  label={{ visible: false }}
                  dataField="type"
                  editorType="dxSelectBox"
                  editorOptions={{
                    dataSource: investorType,
                    stylingMode: "underlined",
                    placeholder: "Type",
                  }}
                />
                <Item
                  label={{ visible: false }}
                  dataField="status"
                  editorType="dxSelectBox"
                  editorOptions={{
                    dataSource: investorStatus,
                    stylingMode: "underlined",
                    placeholder: "Status",
                  }}
                />
                <Item
                  label={{ visible: false }}
                  dataField="contact_person"
                  editorType="dxSelectBox"
                  editorOptions={{
                    dataSource: whoseContactList,
                    stylingMode: "underlined",
                    placeholder: "Whose Contact",
                  }}
                />
                <Item
                  label={{ visible: false }}
                  dataField="priority"
                  editorType="dxSelectBox"
                  editorOptions={{
                    dataSource: priority,
                    stylingMode: "underlined",
                    placeholder: "Priority",
                  }}
                />
                <Item
                  label={{ visible: false }}
                  dataField="relationship_manager"
                  editorType="dxSelectBox"
                  editorOptions={{
                    dataSource: this.props.formFields.relationship_managers_choices,
                    stylingMode: "underlined",
                    placeholder: "Relationship Manager",
                  }}
                />
                <Item
                  label={{ visible: false }}
                  dataField="tags"
                  editorType="dxSelectBox"
                  editorOptions={{
                    dataSource: this.props.formFields.tag_choices,
                    stylingMode: "underlined",
                    placeholder: "Tags",
                  }}
                />
                <Item
                  editorType="dxButton"
                  editorOptions={{
                    text: "Clear",
                    stylingMode: "outlined",
                    type: "danger",
                    icon: "remove",
                    onClick: this.clearFilter,
                  }}
                />
              </Form>
            </form>
          </div>
        </div>
      </>
    );
  }
}
export default connect(mapStateToProps)(ReportsFilter);
